<template>
  <div
    :class="[
      organism.containerWidth ? 'container-' + organism.containerWidth : '',
      'px-4 organism image xl:px-0',
    ]"
  >
    <div v-if="organism.link1">
      <NuxtLink :href="organism.link1" class="hover:opacity-80">
        <img
          class="mx-auto"
          v-bind="imageAttrs"
        />
      </NuxtLink>
    </div>
    <div v-else>
      <img v-bind="imageAttrs" />
    </div>
  </div>
</template>

<script setup>
import { getImageSrc, addFullWidthSupport } from '~/composables/helpers';

const props = defineProps({
  organism: Object,
});

// Use responsive image composable for performance optimization
const imageAttrs = computed(() => {
  const responsiveAttrs = useResponsiveImage(props.organism.image);

  // Fall back to getImageSrc if sourceUrl is not available
  if (!responsiveAttrs.src && props.organism.image) {
    return {
      ...responsiveAttrs,
      src: getImageSrc(props.organism.image)
    };
  }

  return responsiveAttrs;
});

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});
</script>
